/*
 * This is a custom tooltip for ChartJS that displays a gray
 * vertical line over the active index.
 */

const Style = require("@vg-faset/core/styles/export-js.scss");

export default {
	id: "linePlugin",
	beforeDatasetsDraw: function (chart) {
		if (chart.tooltip._active && chart.tooltip._active.length) {
			let activePoint = chart.tooltip._active[0];
			let ctx = chart.ctx;
			let y_axis = chart.scales["y-axis-0"];
			let x = activePoint.tooltipPosition().x;
			let topY = 0;
			let bottomY = y_axis.bottom;

			// Extend line over x axis for synced charts
			if (ctx.canvas.parentNode.classList.contains("line-chart--synced")) {
				bottomY = ctx.canvas.height;
			}
			// draw line
			ctx.save();
			ctx.beginPath();
			ctx.moveTo(x, topY);
			ctx.lineTo(x, bottomY);
			ctx.lineWidth = 2;
			ctx.strokeStyle = Style.colorLighterGray;
			ctx.stroke();
			ctx.restore();
		}
	}
};
